import ACTION from "../../actions";

const initialState = {
  addOfferDiscussionComment: {},
  editOfferDiscussionComment: {},
  offerCommentListing: {},
  offerdocumentsSendRequestDoc: [],
  offerdocumentsFileUpload: {},
  offerdocumentsFileUploadEdit: {},
};
const documentReducer = (state = initialState, actions) => {
  switch (actions.type) {
    case ACTION.OFFER_ACTION_DISCUSSION_CANDIDATE_COMMENT:
      return {
        ...state,
        addOfferDiscussionComment: actions.addOfferDiscussionComment,
      };
    case ACTION.OFFER_ACTION_DISCUSSION_CANDIDATE_EDIT_COMMENT:
      return {
        ...state,
        editOfferDiscussionComment: actions.editOfferDiscussionComment,
      };
    case ACTION.OFFER_ACTION_DISCUSSION_GET_CANDIDATE_COMMENT:
      return {
        ...state,
        offerCommentListing: actions.offerCommentListing,
      };

    case ACTION.OFFERDOCUMENT_ACTION_DOCUMENTS_SENDREQUESTEDDOC:
      return {
        ...state,
        offerdocumentsSendRequestDoc: actions.offerdocumentsSendRequestDoc,
      };
    case ACTION.OFFERDOCUMENT_ACTION_DOCUMENTS_FILEUPLOAD:
      return { ...state, offerdocumentsFileUpload: actions.payload };
    case ACTION.OFFERDOCUMENT_ACTION_DOCUMENTS_FILEUPLOAD_EDIT:
      return {
        ...state,
        offerdocumentsFileUploadEdit: actions.offerdocumentsFileUploadEdit,
      };
    default:
      return state;
  }
};
export default documentReducer;
